import { render, staticRenderFns } from "./RegFail.vue?vue&type=template&id=1818aaa4&"
import script from "./RegFail.vue?vue&type=script&lang=js&"
export * from "./RegFail.vue?vue&type=script&lang=js&"
import style0 from "./RegFail.vue?vue&type=style&index=0&id=1818aaa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports